import { createAsyncThunk } from "@reduxjs/toolkit"
import { getRequest } from "./utils/GetRequest"
import { TypeMappingObject } from "../model/configModels/TypeMappingObject.model"
import { RootState } from "../root-redux/RootState";

  export const getTypeByKeyMapping = createAsyncThunk<TypeMappingObject,string,{ state: RootState}>('typemapping/getTypeMapping', async (key:string, {getState}) => {
    const selectedEnv = getState().env.selectedEnvItem
    const response = await getRequest<TypeMappingObject>(`${selectedEnv}/typemapping/`+key)
    return response.data
  })